// import React from "react";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children, roles }) => {
//   const token = localStorage.getItem("token");
//   const role = localStorage.getItem("role");

//   if (!token) return <Navigate to="/login" />;

//   if (roles && !roles.includes(role)) return <Navigate to="/login" />;

//   return children;
// };

// export default PrivateRoute;

import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, roles }) => {
  const data = sessionStorage.getItem("currentUser");
  const currentUser = data ? JSON.parse(data) : null;

  if (!currentUser || !currentUser.token) {
    return <Navigate to="/login" />;
  }

  if (roles && !roles.includes(currentUser.role)) {
    return <Navigate to="/login" />;
  }

 // Pass currentUser to the child component
  return React.cloneElement(children, { currentUser });
};

export default PrivateRoute;

